window.PackGuard = (function () {
  function parsePackSize(label) {
    const m = String(label || '').match(/(\d+)\s*pack/i);
    return m ? parseInt(m[1], 10) : null;
  }
  const $$ = (sel, root) => Array.from((root && root.querySelectorAll ? root : document).querySelectorAll(sel));
  const $  = (sel, root) => (root && root.querySelector ? root : document).querySelector(sel);

  function init(sectionId) {
    const root = document.getElementById(`ProductInfo-${sectionId}`) || document;
    if (root.dataset.packGuardInit === '1') return;           // avoid double init
    root.dataset.packGuardInit = '1';

    const form = $('product-form form', root);
    const buyNowWrap = $('.shopify-payment-button', root);

    // Variant dataset from Liquid
    const dataEl = document.getElementById(`ProductVariants-${sectionId}`);
    if (!dataEl) return;

    let variants = [];
    try { variants = JSON.parse(dataEl.textContent || '[]'); } catch { return; }

    const ten   = variants.find(v => parsePackSize(v.title) === 10);
    const fifty = variants.find(v => parsePackSize(v.title) === 50);
    
    if (!ten || !fifty) return;

    const computeAllowed = () => Math.floor((Number(ten.inventory) || 0) / 5);
    const fiftyIsAllowed = () => computeAllowed() > 0;

    const getSelectedVariantId = () => {
      const idInput = form?.querySelector('input[name="id"]');
      return idInput ? Number(idInput.value) : null;
    };
    const isFiftySelected = () => {
      const current = variants.find(v => v.id === getSelectedVariantId());
      return parsePackSize(current?.title) === 50;
    };

    function updatePickers() {
      const allowed = fiftyIsAllowed();

      // Radios (button picker)
      $$(root, 'variant-radios input[type="radio"]').forEach(input => {
        const size = parsePackSize(input.value);
        if (size === 50) {
          input.disabled = !allowed;
          const label = input.closest('label') || input.parentElement;
          if (label) label.style.opacity = allowed ? '' : '0.5';
          if (!allowed && input.checked) {
            const tenInput = $$(root, 'variant-radios input[type="radio"]').find(i => parsePackSize(i.value) === 10);
            if (tenInput) tenInput.click();
          }
        }
      });

      // Dropdowns
      $$(root, 'variant-selects select').forEach(select => {
        Array.from(select.options).forEach(opt => {
          const size = parsePackSize(opt.text || opt.value);
          if (size === 50) opt.disabled = !allowed;
        });
        const current = select.options[select.selectedIndex];
        if (!allowed && parsePackSize(current?.text || current?.value) === 50) {
          const tenOpt = Array.from(select.options).find(o => parsePackSize(o.text || o.value) === 10);
          if (tenOpt) {
            select.value = tenOpt.value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      });

      // Hide dynamic checkout to avoid bypass
      if (buyNowWrap) buyNowWrap.style.display = allowed ? '' : 'none';

      // Optional status message
      const msg = $('.pack-guard-message', root);
      if (msg) msg.textContent = allowed
        ? `Up to ${computeAllowed()} × 50-packs available`
        : `50-pack unavailable (not enough 10-packs)`;
    }

    // Block submit as a last line of defense
    if (form) {
      form.addEventListener('submit', (e) => {
        if (isFiftySelected() && !fiftyIsAllowed()) {
          e.preventDefault();
          alert('50-pack is unavailable because not enough 10-packs are in stock.');
        }
      });
    }

    // Initial + on picker changes + when theme re-renders the section
    updatePickers();
    root.addEventListener('change', (e) => {
      if (e.target.closest('variant-radios, variant-selects')) updatePickers();
    });
  }

  return { init };
})();